
function footerLogoAnimation() {

    jQuery(document).ready(function () {

        gsap.registerPlugin(ScrollTrigger);

        gsap.from("footer", {
            scrollTrigger: {
                trigger: "footer",
                start: "top bottom",
                toggleActions: "play none none reverse",
            },
            y: 30,
            duration: .5
        });


        // Split text into spans
        const nameEl = document.querySelector(".footer-details .name");
        const chars = nameEl.textContent.split("");

        nameEl.innerHTML = chars.map(char => `<span>${char}</span>`).join("");

        // Animate characters
        gsap.fromTo(
            ".footer-details .name span",
            { opacity: 0, y: 60 },
            {
                opacity: 1,
                y: 0,
                duration: 1,
                ease: "power3.out",
                stagger: 0.08,
                scrollTrigger: {
                    trigger: ".footer-details",
                    start: "center bottom",
                    toggleActions: "play none none reverse",
                }
            }
        );


    })

}

export default footerLogoAnimation;